import {observer} from "mobx-react";
import {useState} from "react";
import {ShippingTable} from "./ShippingTable";
import {ShippingReceiptExitsBarChart} from "./ShippingReceiptExitsBarChart";
import {kpiShippingRecordReceiptExitStore} from "../../../store";
import {ShippingReceiptExitsLineChart} from "./ShippingReceiptExitsLineChart";

const ShippingRecordReceiptExits = observer(function ShippingRecordReceiptExits() {
    const [tab, setTab] = useState<'linechart' | 'barchart' | 'exit' | 'receipt'>('linechart')
    return <>
        <div className="card">
            <header className="card-header">
                <p className="card-header-title">Versandaus- & Eingänge (Akten)</p>
            </header>
            <div className="tabs is-boxed is-small" style={{marginBottom: '0'}}>
                <ul>
                    <li className={tab === 'linechart' ? 'is-active' : ''}>
                        <a href={'#chart'} onClick={e => {
                            e.preventDefault()
                            setTab('linechart')
                        }}>
                            <span className="material-symbols-outlined">line_axis</span>
                            <span>Total</span>
                        </a>
                    </li>
                    <li className={tab === 'barchart' ? 'is-active' : ''}>
                        <a href={'#chart'} onClick={e => {
                            e.preventDefault()
                            setTab('barchart')
                        }}>
                            <span className="material-symbols-outlined">bar_chart_4_bars</span>
                            <span>Detail</span>
                        </a>
                    </li>
                    <li className={tab === 'exit' ? 'is-active' : ''}>
                        <a href={'#table'} onClick={e => {
                            e.preventDefault()
                            setTab('exit')
                        }}>
                            <span className="material-symbols-outlined">table</span>
                            <span>Ausgänge</span>
                        </a>
                    </li>
                    <li className={tab === 'receipt' ? 'is-active' : ''}>
                        <a href={'#table'} onClick={e => {
                            e.preventDefault()
                            setTab('receipt')
                        }}>
                            <span className="material-symbols-outlined">table</span>
                            <span>Eingänge</span>
                        </a>
                    </li>
                </ul>
            </div>
            <div style={{height: '20em', display: 'flex'}}>
                {tab === 'exit' && <>
                    <ShippingTable data={kpiShippingRecordReceiptExitStore.dataExit} />
                </>}
                {tab === 'receipt' && <>
                    <ShippingTable data={kpiShippingRecordReceiptExitStore.dataReceipt} />
                </>}
                {tab === 'barchart' && <>
                    <ShippingReceiptExitsBarChart
                        chartData={kpiShippingRecordReceiptExitStore.chartData}
                        availableTypes={kpiShippingRecordReceiptExitStore.availableTypes}
                    />
                </>}
                {tab === 'linechart' && <>
                    <ShippingReceiptExitsLineChart
                        chartData={kpiShippingRecordReceiptExitStore.chartData}
                        availableTypes={kpiShippingRecordReceiptExitStore.availableTypes}
                    />
                </>}
            </div>
        </div>
    </>
})

export {
    ShippingRecordReceiptExits
}
